import { apiGet } from '../../generic/Api_Functions'
import { useSmartInterval } from '../../generic/hooks/useSmartInterval'
import FabricationOrders from './FabricationOrder/FabricationOrders'
import Assets from './asset/Assets'

const ToolTables = () => {
  useSmartInterval(
    async () => {
      await apiGet('loadToolTables')
    },
    30000, (data) => { }
  )

  return (
    <>
      <FabricationOrders />
      <Assets />
    </>
  )
}
export default ToolTables
